import React, { useEffect, useRef } from 'react'
import Navbar from '@components/nav/nav'
import styled from 'styled-components'
import useSite from '@hooks/useSite'
import { classNames } from '@utils/genUtils'

interface IProps {
  path: string
  siteTitle: string
  stickyNav: boolean
  showNav: boolean
}

const Header = ({ path, siteTitle, stickyNav, showNav }: IProps) => {
  const [isTop, setIsTop] = React.useState(true)

  const headerRef = useRef(null);
  const prevState = useRef(isTop)

  useEffect(() => {
    const handleScroll = () => {
      const scrollAmount = 200;
      const winScroll =
        document.body.scrollTop || document.documentElement.scrollTop;

      // if scroll is past 200 and its currently true -> change)
      if (winScroll >= scrollAmount && prevState.current) {
        setIsTop(false);
      } else if (winScroll < scrollAmount && !prevState.current) {
        setIsTop(true);
      }

    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    prevState.current = isTop
  }, [isTop])


  return (
    <HeaderContainer
      className={classNames(stickyNav ? 'fixed' : 'absolute')}
      ref={headerRef}
      path={path}
      isTop={isTop}>
      {showNav && <Navbar path={path} isTop={isTop} />}
    </HeaderContainer>
  )
}
const HeaderContainer = styled.div<{ path: string, isTop: boolean }>`
  background: ${props => (props.path === '/' && props.isTop)
    ? 'transparent'
    : props.theme.nav.background
      ? props.theme.nav.background
      : props.theme.backgroundPrimary
  };
  display: flex;
  z-index: 10;
  width: 100%;
  will-change: background;
  transition: .3s background;
`
export default Header
